import styled from '@emotion/styled';
import { theme } from '@britishcouncil/react-extro-ui/dist/theme/theme';
import { Modal, spacingFn } from '@britishcouncil/react-extro-ui';
import nppTheme from '../styles/nppTheme';

export const NppModal = styled(Modal)`
  max-height: calc(100vh - ${theme.spacing.xxl});
  margin-top: auto;
  margin-bottom: auto;
  overflow-y: auto;
  max-width: ${spacingFn(119)};
`;

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${theme.spacing.md};
  gap: ${nppTheme.alert.modal.spacing};
`;

export const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md};
`;

export const Card = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${theme.spacing.md};
  border: 1px solid #d4d4d4;
  border-radius: ${theme.spacing.sm};
  padding: ${theme.spacing.xl};
`;

export const CardIconWrapper = styled.div`
  flex-shrink: 0;
  width: ${spacingFn(6)};
  height: ${spacingFn(6)};
  border-radius: 50%;
  background-color: ${theme.colors.indigo};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.colors.segment.white};
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};
`;

export const CardTitle = styled.p`
  margin: 0;
  font-weight: 600;
  color: ${theme.colors.text.header};
  font-size: ${theme.fontSize.mobile.h4};
`;

export const CardDescription = styled.p`
  margin: 0;
  font-size: ${theme.fontSize.mobile.body};
  color: ${theme.colors.text.body};
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${theme.spacing.md};

  ${({ theme }) => theme.mediaQueries.md} {
    flex-direction: row;
    align-items: center;
  }

  Button {
    color: ${theme.colors.text.header};

    &.stay-button {
      background-color: ${theme.colors.indigo};
      color: ${theme.colors.segment.white};
    }
  }
`;
